import type { FC } from 'react';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiSellerDiscount } from '@wix/da-papi-types';
import { BiData, EditDiscountClickBiEvent } from '@wix/da-bi/pkg/events';
import IconButtonWithContextMenu from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import VerticalEllipsisIcon from '@wix/da-ds/pkg/Icons/16x16/VerticalEllipsis';
import { StudioSection } from '../../../../../types/store';
import { useButtonVisibility } from '../../SellerDiscountModal/hooks';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';

interface Props {
  discount: PapiSellerDiscount;
  isActive: boolean;
  className?: string;
  activeSection?: StudioSection;
  onEditClick: () => void;
  onDuplicateClick: () => void;
  onDeleteClick: () => void;
  onEndDiscountClick: () => void;
}

const MoreButton: FC<Props> = ({
  className,
  discount,
  activeSection,
  onEditClick,
  onDuplicateClick,
  onDeleteClick,
  onEndDiscountClick,
  isActive,
}) => {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { showDelete, showDuplicate, showEdit, showEndDiscount } =
    useButtonVisibility(activeSection, isActive);

  return (
    <IconButtonWithContextMenu
      className={className}
      placement={'bottom-start'}
      items={[
        showEdit && {
          label: t('common.edit'),
          onClick: onEditClick,
          biData: BiData<EditDiscountClickBiEvent>({
            evid: 452,
            campaignid: discount.discountId,
          }),
        },
        showDuplicate && {
          label: t('common.duplicate'),
          onClick: onDuplicateClick,
        },
        showDelete && {
          label: t('common.delete'),
          onClick: onDeleteClick,
        },
        showEndDiscount && {
          label: t('studio.discountRow.endDiscount'),
          onClick: onEndDiscountClick,
        },
      ]}
      size="medium"
      variant="main"
      icon={isMobile ? VerticalEllipsisIcon : EllipsisIcon}
      aria-label={t('common.more')}
      onClick={e => e.stopPropagation()}
      title={t('common.more')}
      standardMenuProps={{ usePortal: false } as any}
    />
  );
};
MoreButton.displayName = 'MoreButton';

export default MoreButton;
